var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-xs-12 spinner-wrapper\">\n<p class=\"text-center\">\n<span us-spinner></span>\n</p>\n</div>\n";
var id1="app/next-times/next-times-spinner.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/next-times/next-times-spinner.tpl.html
// module id = 460
// module chunks = 0